import React, { useContext } from "react";
import "../styles/QualityServices.css";
import dogsAndCats from "../assets/dogs and cats.png";
import qualityServiceBg from "../assets/quality service bg.png";
import qualityBonesLeft from "../assets/quality bones left.png";
import qualityPawsLeft from "../assets/quality paws left.png";
import qualityPawsRight from "../assets/quality paws right.png";
import { LanguageContext } from "../LanguageContext";

const QualityServices = () => {
  const { language } = useContext(LanguageContext); // Use the context

  // Text content for English and Arabic
  const text = {
    en: {
      title: "Quality Services",
      description:
        "We offer a range of services to enhance the bond between humans and pets: Rescue connects users with local organizations to help pets find loving homes, Adopt introduces users to adorable pets, Playtime offers hosting opportunities, and Lost & Found reunites lost pets with their owners. Additional services like boarding, training, and pet supplies are provided by trusted partners.",
    },
    ar: {
      title: "خدمات عالية الجودة",
      description:
        "نقدم مجموعة من الخدمات لتعزيز الرابطة بين البشر والحيوانات الأليفة: الإنقاذ يربط المستخدمين بالمنظمات المحلية لمساعدة الحيوانات الأليفة في العثور على منازل محبة، التبني يعرّف المستخدمين على حيوانات أليفة رائعة، وقت اللعب يوفر فرص الاستضافة، والقسم المفقود والموجود يعيد لمّ شمل الحيوانات الأليفة المفقودة مع أصحابها. يتم تقديم خدمات إضافية مثل الإيواء والتدريب وإمدادات الحيوانات الأليفة من قبل شركاء موثوق بهم.",
    },
  };

  // Fallback to English if language is invalid
  const currentText = text[language] || text.en;

  return (
    <section className={`quality-services ${language === "ar" ? "rtl" : ""}`}>
      <img
        src={qualityBonesLeft}
        alt="bones Print"
        className="bones-print top-left"
      />
      <img
        src={qualityPawsLeft}
        alt="bones Print"
        className="bones-print bottom-left"
      />
      <img
        src={qualityPawsRight}
        alt="bones Print"
        className="bones-print top-right"
      />

      <div className={`content ${language === "ar" ? "rtl" : ""}`}>
        <h2 dir={language === "ar" ? "rtl" : "ltr"}>{currentText.title}</h2>
        <p>{currentText.description}</p>
      </div>
      <img
        src={qualityServiceBg}
        alt="bones Print"
        className="bones-print center-right"
      />

      <div className="images">
        <img src={dogsAndCats} alt="dogsAndCats" />
      </div>
    </section>
  );
};

export default QualityServices;
